import ThemeModel from '../ThemeModel';
import image from "../../assets/arena_online_logo.png";

const Theme = new ThemeModel({
  site_name: 'ARENA ONLINE',
  site_name_header: 'ARENA ONLINE',
  logo_site: image,
});

export default Theme;